import { createStyles, makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    header: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
    },
    formTitles: {
      fontWeight: 'bolder',
    },
    paper: {
      padding: theme.spacing(3),
      marginBottom: theme.spacing(2),
    },
    chips: {
      marginBottom: theme.spacing(2),
    },
    description: {
      whiteSpace: 'pre-wrap',
      marginBottom: theme.spacing(2),
    },
    comment: {
      padding: theme.spacing(2),
      marginBottom: theme.spacing(1),
    },
  }),
);
